var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UseCase } from "../../../../hooks/useUseCase";
import { drillApi } from "../../apis/DrillApi";
import { workApi } from "../../apis/WorkApi";
import { getDrillTypeIdFromName } from "../../utils/Drill";
import { FetchedWorksErrorPayload } from "./payload/FetchedWorksErrorPayload";
import { FetchedWorksPayload } from "./payload/FetchedWorksPayload";
import { FinishedLoadingPayload } from "./payload/FinishedLoadingPayload";
import { StartedLoadingPayload } from "./payload/StartedLoadingPayload";
var FetchWorksUseCase = /** @class */ (function (_super) {
    __extends(FetchWorksUseCase, _super);
    function FetchWorksUseCase(args) {
        if (args === void 0) { args = {}; }
        var _this = _super.call(this) || this;
        _this.infra = __assign({ workApi: workApi, drillApi: drillApi }, args);
        return _this;
    }
    FetchWorksUseCase.prototype.execute = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var response, courseList_1, checkedWorks, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dispatch(new StartedLoadingPayload());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.infra.workApi.getWorksByPage(props.filterCondition, props.sortCondition, props.page || 1, props.userId)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, this.infra.drillApi.getCourseListWithKana()];
                    case 3:
                        courseList_1 = _a.sent();
                        checkedWorks = response.works.map(function (work) {
                            // ワークに紐付く教材の学年・ドリル種別に相当するコース情報を取得する
                            var targetCourses = (function () {
                                return courseList_1.filter(function (_a) {
                                    var grade = _a.grade, drillType = _a.drillType;
                                    return grade === work.grade && drillType === getDrillTypeIdFromName(work.drillType);
                                });
                            })();
                            // 教科書出版社が変更された判定
                            if (!targetCourses.some(function (_a) {
                                var publisherId = _a.publisherId;
                                return publisherId === work.publisherId;
                            })) {
                                work.changeUnavailableCourse();
                            }
                            // 教科書改訂により使えなくなった(courseIdが変わった)判定
                            if (!targetCourses.some(function (_a) {
                                var id = _a.id;
                                return id === work.courseId;
                            })) {
                                work.changeInvalidCourse();
                            }
                            return work;
                        });
                        this.dispatch(new FetchedWorksPayload({ works: checkedWorks, pagination: response.pagination }));
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        console.error("FetchWorksUseCase: \u30EF\u30FC\u30AF\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002 " + error_1);
                        this.dispatch(new FetchedWorksErrorPayload());
                        return [3 /*break*/, 6];
                    case 5:
                        this.dispatch(new FinishedLoadingPayload());
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return FetchWorksUseCase;
}(UseCase));
export { FetchWorksUseCase };
